import { useState } from 'react';
import moment from 'moment-jalaali';

export default function ReportAccordion({ report }) {
  const [open, setOpen] = useState(false);

  // تبدیل تاریخ (با اطمینان از تبدیل به شیء Date برای جلوگیری از خطای پارس رشته)
  const reportDate = report.date || report.createdAt;
  const dateFormatted = moment(new Date(reportDate)).format('jYYYY/jMM/jDD');

  const photos = [
    ...(report.data?.map((d) => d.url) || []),
    ...(report.extraPhotos || []),
  ];

  // تابع کمکی برای نمایش هر آیتم در برنامه دوره بعد
  const PlanItem = ({ label, value, unit = '' }) => (
    <div className="bg-white/60 p-1.5 rounded border border-blue-100 text-center">
      <div className="text-[9px] text-blue-500 mb-0.5">{label}</div>
      <div className="text-[11px] font-bold text-blue-900">
        {value || '0'} <span className="text-[8px] font-normal">{unit}</span>
      </div>
    </div>
  );

  return (
    <div className="border rounded-xl bg-white mb-3 overflow-hidden shadow-sm transition-all">
      {/* Header */}
      <button
        onClick={() => setOpen(!open)}
        className={`w-full text-right p-4 flex justify-between items-center transition-colors ${
          open ? 'bg-blue-50/50' : 'hover:bg-gray-50'
        }`}>
        <div className="flex items-center gap-3">
          <span className="font-bold text-gray-700">{dateFormatted}</span>
          <span className="text-[10px] px-2 py-0.5 bg-gray-100 rounded text-gray-500">
            {report.type === 'weekly' ? 'هفتگی' : 'ماهانه'}
          </span>
          {report.coachFeedback?.comment && (
            <span className="text-[10px] text-green-600 font-medium">
              ✓ فیدبک دارد
            </span>
          )}
        </div>
        <span className="text-gray-400 text-xs">
          {open ? 'بستن ▲' : 'مشاهده ▼'}
        </span>
      </button>

      {open && (
        <div className="p-4 border-t space-y-5 animate-in slide-in-from-top-2 duration-300">
          {/* ۱. آمار گزارش کاربر (Metrics) */}
          <div className="grid grid-cols-4 gap-2 text-center">
            <MetricBox label="کالری مصرفی" value={report.avgCalories} />
            <MetricBox label="میانگین قدم" value={report.avgSteps} />
            <MetricBox label="قدرتی" value={report.strengthDays} />
            <MetricBox label="هوازی" value={report.cardioDays} />
          </div>

          {/* ۲. تصاویر */}
          {photos.length > 0 && (
            <div className="grid grid-cols-3 gap-2">
              {photos.map((src, i) => (
                <img
                  key={i}
                  src={src}
                  className="rounded-lg border object-cover h-28 w-full shadow-sm"
                  alt="progress"
                />
              ))}
            </div>
          )}

          {/* ۳. یادداشت کاربر */}
          {report.note && (
            <div className="text-xs bg-amber-50 p-3 rounded-lg border-r-4 border-amber-400 text-gray-700">
              <span className="font-bold block mb-1">توضیح شاگرد:</span>
              {report.note}
            </div>
          )}

          {/* ۴. بخش فیدبک مربی و برنامه دوره بعد */}
          {report.coachFeedback?.comment ? (
            <div className="bg-blue-50 p-4 rounded-xl border border-blue-100">
              <div className="flex justify-between items-center mb-3">
                <div className="font-bold text-blue-800 text-sm">فیدبک شما</div>
                <div className="text-[10px] bg-blue-600 text-white px-2 py-0.5 rounded-full">
                  امتیاز: {report.coachFeedback.score}
                </div>
              </div>

              <p className="text-gray-700 text-xs italic leading-relaxed mb-4">
                "{report.coachFeedback.comment}"
              </p>

              {/* نمایش برنامه دوره بعد (Next Period Plan) */}
              {report.coachFeedback.nextPeriodPlan && (
                <div className="mt-4 pt-3 border-t border-blue-200/50">
                  <div className="font-bold text-blue-700 text-[10px] mb-2">
                    برنامه تعیین شده برای دوره بعد:
                  </div>
                  <div className="grid grid-cols-3 md:grid-cols-4 gap-2">
                    <PlanItem
                      label="کالری هدف"
                      value={report.coachFeedback.nextPeriodPlan.dailyCalories}
                      unit="kcal"
                    />
                    <PlanItem
                      label="پروتئین"
                      value={report.coachFeedback.nextPeriodPlan.proteinPercent}
                      unit="%"
                    />
                    <PlanItem
                      label="کربوهیدرات"
                      value={report.coachFeedback.nextPeriodPlan.carbsPercent}
                      unit="%"
                    />
                    <PlanItem
                      label="چربی"
                      value={report.coachFeedback.nextPeriodPlan.fatPercent}
                      unit="%"
                    />
                    <PlanItem
                      label="هدف قدم"
                      value={
                        report.coachFeedback.nextPeriodPlan.dailyStepsTarget
                      }
                    />
                    <PlanItem
                      label="فیبر"
                      value={report.coachFeedback.nextPeriodPlan.fiberTarget}
                      unit="g"
                    />
                    <PlanItem
                      label="روز تمرین"
                      value={
                        report.coachFeedback.nextPeriodPlan.trainingDaysTarget
                      }
                    />
                    <PlanItem
                      label="هوازی"
                      value={
                        report.coachFeedback.nextPeriodPlan.cardioDaysTarget
                      }
                    />
                  </div>
                </div>
              )}
            </div>
          ) : (
            <div className="text-center py-4 border-2 border-dashed border-gray-100 rounded-xl">
              <p className="text-[10px] text-gray-400 italic">
                برای این گزارش فیدبکی ثبت نکرده‌اید.
              </p>
            </div>
          )}
        </div>
      )}
    </div>
  );
}

// تابع کمکی برای نمایش باکس‌های آمار گزارش شاگرد
function MetricBox({ label, value }) {
  return (
    <div className="bg-gray-50 p-2 rounded-lg border border-gray-100">
      <div className="text-[9px] text-gray-400 mb-0.5">{label}</div>
      <div className="text-xs font-black text-gray-700">{value || '-'}</div>
    </div>
  );
}
